import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { mapTo } from 'rxjs/operators';
import { preloadColumnNameOverrides } from '../utils/site-monitoring-guards.utils';
import { SiteMonitoringFacade } from '../store/site-monitoring.facade';

@Injectable({ providedIn: 'root' })
export class PreloadColumnNameOverridesGuard  {
  constructor(private _siteMonitoringFacade: SiteMonitoringFacade) {}

  /**
   * Fetches the requested data for the route
   */
  canActivate(): Observable<boolean> {
    // fetch the data for our route if needed (not previously loaded)
    return preloadColumnNameOverrides(this._siteMonitoringFacade).pipe(
      mapTo(true)
    );
  }
}
